export default __webpack_public_path__ + "static/media/invite_friends.01897851.png";